/* ==========================================================================
   BullRun ⚡ – comportamente globale
   Config: window.BR.settings (snippets/br-head.liquid)
   API atribute: data-br-reveal, data-br-inview, data-br-count, data-br-countdown,
   data-br-ba, data-br-copy, data-br-delivery, data-br-savings, data-br-stock
   ========================================================================== */
(function () {
  'use strict';

  var BR = (window.BR = window.BR || {});
  var S = BR.settings || {};
  var d = document;
  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var design = !!(window.Shopify && window.Shopify.designMode);

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || d).querySelectorAll(sel));
  }
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function storage(type) {
    try {
      var s = window[type];
      s.setItem('__br', '1');
      s.removeItem('__br');
      return s;
    } catch (e) {
      return null;
    }
  }
  var ss = storage('sessionStorage');
  function sget(k) {
    try { return ss ? ss.getItem(k) : null; } catch (e) { return null; }
  }
  function sset(k, v) {
    try { if (ss) ss.setItem(k, v); } catch (e) { /* storage indisponibil */ }
  }
  function cssVar(name, fallback) {
    var v = getComputedStyle(d.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = d.createElement('div');
      toastEl.className = 'br-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      d.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2200);
  }
  BR.toast = toast;

  /* ---------- Bani (format Shopify) ---------- */
  function formatMoney(cents, format) {
    var f = String(format || BR.moneyFormat || '{{amount_with_comma_separator}} lei').replace(/<[^>]*>/g, '');
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(num, prec, thou, dec) {
      thou = thou == null ? ',' : thou;
      dec = dec == null ? '.' : dec;
      if (num == null || isNaN(num)) return '0';
      var parts = (num / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou) + (parts[1] ? dec + parts[1] : '');
    }
    var m = f.match(ph);
    if (!m) return f;
    var value;
    switch (m[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return f.replace(ph, value);
  }
  BR.formatMoney = formatMoney;

  /* ---------- Reveal + count-up ---------- */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          e.target.classList.add('is-in');
          if (e.target.hasAttribute('data-br-count')) countUp(e.target);
        });
      }, { threshold: 0.01, rootMargin: '0px 0px -40px 0px' })
    : null;

  function parseNum(raw) {
    var s = String(raw || '').replace(/\s/g, '');
    if (/^\d{1,3}([.,]\d{3})+$/.test(s)) s = s.replace(/[.,]/g, '');
    return parseFloat(s.replace(',', '.'));
  }

  function countUp(el) {
    var target = parseNum(el.getAttribute('data-br-count'));
    if (isNaN(target)) return;
    var dec = parseInt(el.getAttribute('data-br-decimals') || '0', 10);
    var fmt = function (n) {
      return n.toLocaleString('ro-RO', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    };
    if (reduced || design) {
      el.textContent = fmt(target);
      return;
    }
    var dur = parseInt(el.getAttribute('data-br-duration') || '1800', 10);
    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      el.textContent = fmt(target * (1 - Math.pow(1 - p, 4)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initReveal(ctx) {
    $$('[data-br-reveal],[data-br-inview],[data-br-count],.br-checklist,.br-delivery', ctx).forEach(function (el) {
      if (el.__brObs) return;
      el.__brObs = true;
      if (!io || design) {
        el.classList.add('is-in');
        return;
      }
      io.observe(el);
    });
  }

  /* ---------- Countdown până la o dată reală ---------- */
  function parseLocalDate(str) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T ](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], m[4] != null ? +m[4] : 23, m[5] != null ? +m[5] : 59, m[4] != null ? 0 : 59);
  }

  function setDigit(node, value) {
    if (!node) return;
    var t = pad(value);
    if (node.textContent === t) return;
    node.textContent = t;
    if (reduced) return;
    node.classList.remove('br-tick');
    void node.offsetWidth;
    node.classList.add('br-tick');
  }

  function initCountdowns(ctx) {
    $$('[data-br-countdown]', ctx).forEach(function (el) {
      if (el.__brCd) return;
      var end = parseLocalDate(el.getAttribute('data-br-end'));
      if (!end) return;
      el.__brCd = true;
      var parts = {
        d: el.querySelector('[data-br-d]'),
        h: el.querySelector('[data-br-h]'),
        m: el.querySelector('[data-br-m]'),
        s: el.querySelector('[data-br-s]')
      };
      var timer;
      function tick() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) {
          ['d', 'h', 'm', 's'].forEach(function (k) { setDigit(parts[k], 0); });
          el.classList.add('is-expired');
          if (el.hasAttribute('data-br-hide-expired') && !design) {
            (el.closest('.shopify-section') || el).hidden = true;
          }
          clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        var days = Math.floor(s / 86400);
        var hrs = Math.floor((s % 86400) / 3600);
        if (!parts.d) hrs += days * 24;
        setDigit(parts.d, days);
        setDigit(parts.h, hrs);
        setDigit(parts.m, Math.floor((s % 3600) / 60));
        setDigit(parts.s, s % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Înainte / După ---------- */
  function initBeforeAfter(ctx) {
    $$('[data-br-ba]', ctx).forEach(function (el) {
      if (el.__brBa) return;
      var range = el.querySelector('[data-br-ba-range]');
      if (!range) return;
      el.__brBa = true;
      var update = function () {
        el.style.setProperty('--br-pos', range.value + '%');
      };
      range.addEventListener('input', update);
      update();
    });
  }

  /* ---------- Copiere cod reducere ---------- */
  function copyText(text) {
    function fallback() {
      var ta = d.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
      d.body.appendChild(ta);
      ta.select();
      BR._allowCopy = true;
      try { d.execCommand('copy'); } catch (e) { /* ignorat */ }
      BR._allowCopy = false;
      ta.remove();
    }
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(fallback);
    }
    fallback();
    return Promise.resolve();
  }
  d.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-br-copy]');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-br-copy');
    copyText(code).then(function () {
      toast((S.copiedText || 'Cod copiat:') + ' ' + code + ' ✅');
    });
  });

  /* ---------- Livrare estimată (zile lucrătoare + sărbători legale RO) ---------- */
  var RO_DAYS = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
  var RO_MONTHS = ['ian.', 'feb.', 'mar.', 'apr.', 'mai', 'iun.', 'iul.', 'aug.', 'sept.', 'oct.', 'nov.', 'dec.'];

  function orthodoxEaster(y) {
    var a = y % 4, b = y % 7, c = y % 19;
    var dd = (19 * c + 15) % 30;
    var e = (2 * a + 4 * b - dd + 34) % 7;
    var month = Math.floor((dd + e + 114) / 31);
    var day = ((dd + e + 114) % 31) + 1;
    var date = new Date(y, month - 1, day);
    date.setDate(date.getDate() + 13); // calendar iulian -> gregorian (1900–2099)
    return date;
  }
  var holidayCache = {};
  function roHolidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var set = {};
    var add = function (dt) { set[dt.getMonth() + '-' + dt.getDate()] = true; };
    [[0, 1], [0, 2], [0, 6], [0, 7], [0, 24], [4, 1], [5, 1], [7, 15], [10, 30], [11, 1], [11, 25], [11, 26]].forEach(function (p) {
      add(new Date(y, p[0], p[1]));
    });
    var easter = orthodoxEaster(y);
    [-2, 0, 1, 49, 50].forEach(function (offset) {
      var x = new Date(easter);
      x.setDate(x.getDate() + offset);
      add(x);
    });
    holidayCache[y] = set;
    return set;
  }
  function isWorkday(dt, saturday) {
    var wd = dt.getDay();
    if (wd === 0 || (wd === 6 && !saturday)) return false;
    return !roHolidays(dt.getFullYear())[dt.getMonth() + '-' + dt.getDate()];
  }
  function addWorkdays(dt, n, saturday) {
    var x = new Date(dt);
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      if (isWorkday(x, saturday)) n--;
    }
    return x;
  }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function dayLabel(dt, withWeekday) {
    return (withWeekday ? cap(RO_DAYS[dt.getDay()]) + ', ' : '') + dt.getDate() + ' ' + RO_MONTHS[dt.getMonth()];
  }
  BR.deliveryWindow = function (min, max, cutoffHour, shipSaturday) {
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var cutoff = new Date(today);
    cutoff.setHours(cutoffHour, 0, 0, 0);
    var shipsToday = isWorkday(today, shipSaturday) && now < cutoff;
    var ship = shipsToday ? today : addWorkdays(today, 1, shipSaturday);
    return { now: now, today: today, cutoff: cutoff, shipsToday: shipsToday, ship: ship, from: addWorkdays(ship, min, false), to: addWorkdays(ship, max, false) };
  };

  function initDelivery(ctx) {
    $$('[data-br-delivery]', ctx).forEach(function (el) {
      if (el.__brDel) return;
      el.__brDel = true;
      var min = parseInt(el.getAttribute('data-min'), 10) || 1;
      var max = Math.max(parseInt(el.getAttribute('data-max'), 10) || 2, min);
      var cutoffHour = parseInt(el.getAttribute('data-cutoff'), 10);
      if (isNaN(cutoffHour)) cutoffHour = 14;
      var saturday = el.getAttribute('data-saturday') === 'true';
      var msg = el.querySelector('[data-br-delivery-msg]');
      var set = function (key, text) {
        var n = el.querySelector('[data-br-date="' + key + '"]');
        if (n) n.textContent = text;
      };
      function render() {
        var w = BR.deliveryWindow(min, max, cutoffHour, saturday);
        var tomorrow = new Date(w.today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        var shipWord = w.shipsToday ? 'azi' : w.ship.getTime() === tomorrow.getTime() ? 'mâine' : RO_DAYS[w.ship.getDay()];
        var same = w.from.getTime() === w.to.getTime();
        var range = same ? dayLabel(w.from, true) : dayLabel(w.from, true) + ' – ' + dayLabel(w.to, true);
        var short = same
          ? dayLabel(w.from)
          : w.from.getMonth() === w.to.getMonth()
            ? w.from.getDate() + '–' + dayLabel(w.to)
            : dayLabel(w.from) + ' – ' + dayLabel(w.to);
        var time = '';
        if (w.shipsToday) {
          var diff = w.cutoff - w.now;
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          time = (h ? h + 'h ' : '') + pad(m) + 'm ' + pad(s) + 's';
        }
        var tpl = el.getAttribute(w.shipsToday ? 'data-msg-before' : 'data-msg-after') || '';
        if (msg) {
          msg.innerHTML = esc(tpl)
            .replace('{time}', '<strong>' + time + '</strong>')
            .replace('{ship_day}', '<strong>' + shipWord + '</strong>')
            .replace('{range}', '<strong>' + range + '</strong>');
        }
        set('order', 'Azi');
        set('ship', w.shipsToday ? 'Azi' : cap(shipWord === 'mâine' ? 'mâine' : dayLabel(w.ship)));
        set('deliver', short);
      }
      render();
      setInterval(render, 1000);
    });
  }

  /* ---------- Variante (preț, stoc) ---------- */
  var variantEls = [];
  function readVariants(el) {
    if (el.__brVariants) return el.__brVariants;
    var json = el.querySelector('script[type="application/json"][data-br-variants]');
    try { el.__brVariants = json ? JSON.parse(json.textContent) : {}; } catch (e) { el.__brVariants = {}; }
    return el.__brVariants;
  }
  function renderSavings(el, variantId) {
    var v = readVariants(el)[variantId];
    if (!v) return;
    var out = el.querySelector('[data-br-savings-text]');
    if (!v.c || v.c <= v.p) {
      el.hidden = true;
      return;
    }
    var pct = Math.round(((v.c - v.p) / v.c) * 100);
    el.hidden = false;
    if (out) {
      out.textContent = (el.getAttribute('data-tpl') || '')
        .replace('{amount}', formatMoney(v.c - v.p))
        .replace('{percent}', '-' + pct + '%');
    }
  }
  function renderStock(el, variantId) {
    var v = readVariants(el)[variantId];
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 20;
    if (!v || !v.t || !v.a || v.q <= 0 || v.q > threshold) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    var txt = el.querySelector('[data-br-stock-text]');
    if (txt) txt.innerHTML = esc(el.getAttribute('data-tpl') || '').replace('{qty}', '<strong>' + v.q + '</strong>');
    var fill = el.querySelector('.br-stock__fill');
    if (fill) fill.style.setProperty('--br-fill', Math.max(8, Math.min(100, Math.round((v.q / threshold) * 100))) + '%');
  }
  function currentVariantId(el) {
    var formId = el.getAttribute('data-form');
    var form = formId && d.getElementById(formId);
    var input = form && form.querySelector('input[name="id"]');
    return input ? input.value : el.getAttribute('data-variant');
  }
  function renderVariantEl(el, variantId) {
    if (el.hasAttribute('data-br-savings')) renderSavings(el, variantId);
    if (el.hasAttribute('data-br-stock')) renderStock(el, variantId);
  }
  function initVariantBlocks(ctx) {
    $$('[data-br-savings],[data-br-stock]', ctx).forEach(function (el) {
      if (el.__brVar) return;
      el.__brVar = true;
      variantEls.push(el);
      renderVariantEl(el, currentVariantId(el));
    });
    if (!BR._variantBus && typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      BR._variantBus = true;
      window.subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var v = evt && evt.data && evt.data.variant;
        if (!v) return;
        variantEls.forEach(function (el) {
          if (d.contains(el)) renderVariantEl(el, String(v.id));
        });
      });
    }
  }

  /* ---------- Butonul de comandă (app COD / formular extern – fără coș) ---------- */
  var BUY_SELECTORS = [
    '[data-br-buy-target]',
    '.es-form-button', '.es-popup-button', '.es-button',
    '[class*="easysell"] button', '[id*="easysell"] button', '[class*="es-form"] button',
    '[class*="rsi-"] button', '[class*="_rsi"] button', '[class*="releasit"] button',
    '[class*="cod-form"] button', '[class*="codform"] button', '[id*="cod-form"] button', '[class*="cod-button"]'
  ];
  var NATIVE_BUY = 'product-form .product-form__submit, button[name="add"]';
  var BUY_TEXT = /(comand|cumpăr|cumpar|ramburs|plat[ăa] la livrare|order now|buy now)/i;
  function findBuyByText() {
    var scope = d.querySelector('.product__info-container') || d.querySelector('main') || d;
    return $$('button, [role="button"], input[type="submit"], a[href="#"]', scope).filter(function (el) {
      return !el.closest('.br-sticky, .br-modal') && isShown(el) && BUY_TEXT.test(el.textContent || el.value || '');
    })[0] || null;
  }
  function isShown(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }
  function findBuy() {
    var list = (S.buySelector ? [S.buySelector] : []).concat(BUY_SELECTORS);
    for (var i = 0; i < list.length; i++) {
      try {
        var found = $$(list[i]).filter(function (el) {
          return !el.closest('.br-sticky') && isShown(el);
        });
        if (found.length) return found[0];
      } catch (e) { /* selector invalid din setări */ }
    }
    var byText = findBuyByText();
    if (byText) return byText;
    return $$(NATIVE_BUY).filter(function (el) { return !el.closest('.br-sticky') && isShown(el); })[0] || null;
  }
  BR.findBuy = findBuy;

  function openOrderForm() {
    var t = findBuy();
    if (!t) {
      var info = d.querySelector('.product__info-container');
      if (info) info.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      return false;
    }
    t.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    setTimeout(function () {
      BR._syntheticClick = true;
      t.click();
      BR._syntheticClick = false;
    }, reduced ? 0 : 380);
    return true;
  }
  BR.openOrderForm = openOrderForm;

  function initSticky() {
    var bar = d.getElementById('br-sticky');
    if (!bar) return;
    var btn = bar.querySelector('[data-br-sticky-btn]');
    var targetInView = true;
    var target = null;
    var obs = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { targetInView = e.isIntersecting; });
          update();
        })
      : null;
    function pick() {
      var t = findBuy();
      if (!t || t === target) return;
      target = t;
      if (obs) {
        obs.disconnect();
        obs.observe(t);
      }
    }
    function update() {
      var show = !!target && !target.disabled && !targetInView && window.scrollY > 250;
      bar.classList.toggle('is-visible', show);
      d.body.classList.toggle('br-sticky-on', show);
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    pick();
    [800, 2000, 4000].forEach(function (t) { setTimeout(function () { pick(); update(); }, t); });
    window.addEventListener('scroll', update, { passive: true });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openOrderForm();
    });
  }

  /* ---------- Confetti la click pe CTA ---------- */
  function confetti(x, y) {
    if (reduced || !S.confetti) return;
    var canvas = d.createElement('canvas');
    canvas.className = 'br-confetti';
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    d.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    var colors = [cssVar('--br-accent', '#c82828'), cssVar('--br-gold', '#f5b400'), cssVar('--br-success', '#16a34a'), '#2563eb', '#ff7a18'];
    var parts = [];
    for (var i = 0; i < 120; i++) {
      var a = Math.random() * Math.PI * 2;
      var v = 4 + Math.random() * 9;
      parts.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 7, w: 6 + Math.random() * 6, h: 4 + Math.random() * 6, r: Math.random() * 6, vr: (Math.random() - 0.5) * 0.4, c: colors[i % colors.length] });
    }
    var start = performance.now();
    (function frame(now) {
      var t = now - start;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      parts.forEach(function (p) {
        p.vy += 0.3;
        p.vx *= 0.985;
        p.x += p.vx;
        p.y += p.vy;
        p.r += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.r);
        ctx.globalAlpha = Math.max(0, 1 - t / 1700);
        ctx.fillStyle = p.c;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (t < 1700) requestAnimationFrame(frame);
      else canvas.remove();
    })(start);
  }
  BR.confetti = confetti;
  d.addEventListener('click', function (e) {
    if (BR._syntheticClick || !e.target.closest) return;
    var cta = null;
    try {
      cta = e.target.closest('[data-br-sticky-btn], [data-br-cta], ' + BUY_SELECTORS.slice(1).join(', ') + (S.buySelector ? ', ' + S.buySelector : ''));
    } catch (err) { /* selector invalid din setări */ }
    if (!cta) {
      var b = e.target.closest('.product__info-container button');
      if (b && BUY_TEXT.test(b.textContent || '')) cta = b;
    }
    if (!cta || cta.disabled) return;
    var r = cta.getBoundingClientRect();
    confetti(r.left + r.width / 2, r.top + r.height / 2);
  }, true);

  /* ---------- Popup la ieșire ---------- */
  function initExitPopup() {
    var modal = d.getElementById('br-exit');
    if (!modal || design || sget('br_exit_shown')) return;
    var armed = false;
    var shown = false;
    var lastFocus = null;
    setTimeout(function () { armed = true; }, (parseInt(S.exitDelay, 10) || 8) * 1000);
    function open() {
      if (shown || !armed) return;
      if (d.documentElement.classList.contains('br-js-active')) return;
      if (d.querySelector('.br-modal:not([hidden])')) return;
      shown = true;
      sset('br_exit_shown', '1');
      lastFocus = d.activeElement;
      modal.hidden = false;
      d.body.style.overflow = 'hidden';
      var close = modal.querySelector('.br-modal__close');
      if (close) close.focus({ preventScroll: true });
    }
    function close() {
      modal.hidden = true;
      d.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    modal.addEventListener('click', function (e) {
      var cta = e.target.closest('[data-br-exit-cta]');
      if (cta) {
        e.preventDefault();
        var code = cta.getAttribute('data-code');
        close();
        copyText(code).then(function () {
          toast((S.copiedText || 'Cod copiat:') + ' ' + code + ' ✅');
        });
        if (!openOrderForm() && cta.getAttribute('data-fallback')) {
          window.location.href = cta.getAttribute('data-fallback');
        }
        return;
      }
      if (e.target.closest('[data-br-close]')) close();
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
    d.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) open();
    });
    var lastY = window.scrollY, lastT = Date.now(), maxY = 0;
    var mobile = window.matchMedia('(max-width: 749px)');
    window.addEventListener('scroll', function () {
      var y = window.scrollY, t = Date.now();
      maxY = Math.max(maxY, y);
      var speed = (lastY - y) / Math.max(t - lastT, 1);
      if (mobile.matches && maxY > 1400 && speed > 2.5 && y < maxY - 700) open();
      lastY = y;
      lastT = t;
    }, { passive: true });
  }

  /* ---------- Titlu tab când pleacă ---------- */
  function initTabTitle() {
    if (!S.tabTitle || design) return;
    var original = d.title;
    var interval;
    d.addEventListener('visibilitychange', function () {
      if (d.hidden) {
        var frames = [S.tabTitle, S.tabTitle2 || original];
        var i = 0;
        d.title = frames[0];
        interval = setInterval(function () {
          i = i ? 0 : 1;
          d.title = frames[i];
        }, 1800);
      } else {
        clearInterval(interval);
        d.title = original;
      }
    });
  }

  /* ---------- Bară progres scroll ---------- */
  function initProgress() {
    if (!S.scrollProgress) return;
    var bar = d.createElement('div');
    bar.className = 'br-progress';
    d.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = d.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(window.scrollY / h, 1) : 0) + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  /* ---------- Anti copy / paste ---------- */
  function isEditable(t) {
    return !!(t && t.closest && t.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]'));
  }
  function initAntiCopy() {
    if (!S.antiCopy || design) return;
    d.body.classList.add('br-nocopy');
    var lastWarn = 0;
    function warn() {
      if (Date.now() - lastWarn < 1500) return;
      lastWarn = Date.now();
      toast(S.antiCopyText);
    }
    ['copy', 'cut'].forEach(function (type) {
      d.addEventListener(type, function (e) {
        if (BR._allowCopy || isEditable(e.target)) return;
        e.preventDefault();
        warn();
      }, true);
    });
    d.addEventListener('paste', function (e) {
      if (isEditable(e.target) && !S.antiPasteInputs) return;
      e.preventDefault();
      warn();
    }, true);
    d.addEventListener('contextmenu', function (e) {
      if (isEditable(e.target)) return;
      e.preventDefault();
      warn();
    }, true);
    d.addEventListener('selectstart', function (e) {
      if (!isEditable(e.target)) e.preventDefault();
    }, true);
    d.addEventListener('dragstart', function (e) {
      if (e.target && e.target.tagName === 'IMG') e.preventDefault();
    }, true);
    if (S.antiCopyKeys) {
      d.addEventListener('keydown', function (e) {
        var code = e.code || '';
        var mod = e.ctrlKey || e.metaKey;
        var devtools = e.key === 'F12' ||
          (mod && e.shiftKey && /^Key[IJC]$/.test(code)) ||
          (e.metaKey && e.altKey && /^Key[IJCU]$/.test(code));
        if (devtools || (mod && /^Key[USP]$/.test(code))) {
          e.preventDefault();
          warn();
          return;
        }
        if (mod && /^Key[CXA]$/.test(code) && !isEditable(e.target)) {
          e.preventDefault();
          if (code !== 'KeyA') warn();
        }
        if (mod && code === 'KeyV' && isEditable(e.target) && S.antiPasteInputs) {
          e.preventDefault();
          warn();
        }
      }, true);
    }
  }

  /* ---------- Init ---------- */
  function initSections(ctx) {
    initReveal(ctx);
    initCountdowns(ctx);
    initBeforeAfter(ctx);
    initDelivery(ctx);
    initVariantBlocks(ctx);
  }

  function boot() {
    initSections(d);
    initSticky();
    initExitPopup();
    initTabTitle();
    initProgress();
    initAntiCopy();
    BR.ready = true;
  }

  d.addEventListener('shopify:section:load', function (e) { initSections(e.target); });
  d.addEventListener('shopify:block:select', function (e) { initSections(e.target); });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
